// extracted by mini-css-extract-plugin
module.exports = {"TheComp":"SmartInsights_TheComp__cC5ov"};